import { defineMessage } from 'services/localization';
export const messages = {
    title: defineMessage('newer_workflow_version_published'),
    description: defineMessage('either_refresh_the_page__overwrite_others_edits_1'),
    buttonOverwrite: defineMessage('overwrite_1'),
    buttonCancel: defineMessage('continue_editing_2'),
};
